export default __webpack_public_path__ + "static/darkhorse-groundfish-4eacac0c2088489e5b9b53906f8dbcd5.jpg";